import React from "react";
import Searchproduct from "../search/Searchproduct";
import AvailableShops from "./AvailableShops";
import Products from "../products/Products";
import Ajax, { domain } from "../../ajax/Ajax";
import { Loading } from "../../App";
import { Helmet } from "react-helmet/es/Helmet";
import { getLocation } from "../../utils";
import logo from "../../images/logo.png";
import BottomScrollListener from "react-bottom-scroll-listener";
import queryString from "query-string";

class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      location: null,
      products: [],
      initialFetchMade: false,
      failedLocation: false,
      nextFetch: null,
      prevFetch: null,
      fetching: true,
      search: null,
      searching: false,
    };

    this.setLocation = this.setLocation.bind(this);
    this.fetchProducts = this.fetchProducts.bind(this);
    this.fetchMoreProducts = this.fetchMoreProducts.bind(this);
    this.checkQueryParams = this.checkQueryParams.bind(this);
  }

  setLocation(location) {
    if (location) {
      this.setState({
        location: location,
      });
    } else {
      this.setState({
        failedLocation: true,
      });
    }
  }

  async fetchMoreProducts() {
    if (!this.state.fetching) {
      let url =
        domain + this.state.nextFetch.replace("http://127.0.0.1:8001", "");
      console.log("fetching more ...", url);
      this.setState({ fetching: true });
      let fetchResults = await Ajax.fetchData(url);

      if (fetchResults) {
        let currentProducts = this.state.products;
        fetchResults.results.forEach((product) => {
          currentProducts.push(product);
        });
        await this.setState({
          products: currentProducts,
          nextFetch: fetchResults.next,
          prevFetch: fetchResults.previous,
          fetching: false,
        });
      }
    }
  }

  async fetchProducts() {
    let param = "";
    if (this.state.location) {
      param = `lat=${this.state.location.lat}&lon=${this.state.location.lon}`;
    }
    if (this.state.search) {
      param += "&search=" + this.state.search;
    }
    let url = domain + "/en/api/market/v1/?" + param;

    let fetchResults = await Ajax.fetchData(url);
    console.log(fetchResults, "the fetch results");

    if (fetchResults) {
      await this.setState({
        products: fetchResults.results,
        nextFetch: fetchResults.next,
        prevFetch: fetchResults.previous,
        initialFetchMade: true,
        fetchMore: false,
        fetching: false,
        searching: false,
      });
    }
  }

  checkQueryParams() {
    try {
      let params = queryString.parse(this.props.location.search);
      if (params) {
        if (params.search) {
          if (!(params.search === this.state.search)) {
            this.setState(
              {
                search: params.search,
                searching: true,
              },
              this.fetchProducts
            );
          }
        }
      }
    } catch (e) {}
  }

  async componentDidMount() {
    getLocation(this.setLocation);
    this.checkQueryParams();
  }

  async componentDidUpdate(prevProps, prevState, snapshot) {
    if (
      (this.state.location || this.state.failedLocation) &&
      !this.state.initialFetchMade
    ) {
      this.fetchProducts();
    }

    this.checkQueryParams();
  }

  render() {
    return (
      <>
        <br />
        <br />
        <br />

        <Helmet>
          <link rel="icon" href={logo} />
          <title>Market | VehShop</title>
        </Helmet>
        <div className="container">
          <Searchproduct
            location={this.props.location}
            history={this.props.history}
            searching={this.state.searching}
            search={this.state.search}
          />
        </div>

        {!this.state.location && !this.state.failedLocation ? (
          <div className="container">
            <div className="message is-info m-2">
              <div className="message-body">
                <span className="zmdi zmdi-gps mr-2"></span>
                We will need to access your location to get results closer to
                you
              </div>
            </div>
          </div>
        ) : (
          <span></span>
        )}

        <div>
          {this.state.products.length > 0 ? (
            <div className="animated fadeIn">
              <AvailableShops />
            </div>
          ) : (
            <div></div>
          )}
        </div>

        <div className="mt-4">
          {this.state.products.length > 0 ? (
            <div className="container">
              <Products products={this.state.products} />
            </div>
          ) : (
            <div></div>
          )}

          {this.state.fetching ? (
            <div>
              <br />
              <Loading />
              <br />
            </div>
          ) : (
            <div></div>
          )}

          <BottomScrollListener
            onBottom={() => {
              if (this.state.nextFetch) {
                this.fetchMoreProducts();
              }
            }}
          />
        </div>
      </>
    );
  }
}

export default Home;
